/* eslint-disable */
import {Service} from 'components/Shared/server';



export const routePostNotify = (ticket: string, type: string) => `/api/notification/notify?ticket=${encodeURIComponent(ticket)}&type=${encodeURIComponent(type)}`;
export function postNotify(ticket: string, type: string): Promise<Response> {
  return Service.post<Response>({
    url: routePostNotify(ticket, type),
    body: null
  });
}

export const routePostThecaNotifyAsync = (thecaUrl: string) => `/api/notification/thecaNotify?thecaUrl=${encodeURIComponent(thecaUrl)}`;
export function postThecaNotifyAsync(thecaUrl: string): Promise<void> {
  return Service.post<void>({
    url: routePostThecaNotifyAsync(thecaUrl),
    body: null
  });
}
